import {
  REQUEST_SUSPENDER_TIMEOUT_MS,
  requestSuspender,
} from 'serviceWorker/api/RequestSuspender';
import { noop } from 'shared/utils/function';

/**
 * Runs a sync or a read once operations are not suspended (e.g. during a
 * project switch), and resolves with its result. Rejects when they stay suspended, so the requester gets an
 * answer instead of silence.
 */
export async function runWhenRequestsAllowed<TResult>(run: () => TResult | Promise<TResult>): Promise<TResult> {
  const isOpen = await requestSuspender.waitUntilOpen(REQUEST_SUSPENDER_TIMEOUT_MS);
  if (!isOpen) {
    throw new Error('Operations are suspended');
  }
  return run();
}

/**
 * A sync started by a read (fire and forget): during a project switch it
 * waits, and it is skipped when operations stay suspended (the switch syncs);
 * `onSkipped` tells the caller about that.
 */
export function syncWhenRequestsAllowed(sync: () => void, onSkipped: () => void = noop): void {
  runWhenRequestsAllowed(sync).catch(onSkipped);
}
